/* src/app/modules/shared/components/api-call-gate.component.scss */
:host([loaded]) {
  display: contents;
  margin: initial;
}
:host {
  display: flex;
  margin: auto;
}
dialog {
  position: fixed;
  z-index: 100;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
dialog sh-card {
  width: 300px;
  max-width: 80%;
  max-height: 80%;
}
dialog sh-card h3 {
  margin-top: 0px;
  margin-bottom: 1rem;
}
.error {
  scale: 0.8;
  opacity: 0.7;
  overflow: hidden;
  line-break: anywhere;
  text-align: center;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.error h3 {
  margin: 0rem;
}
.error sh-icon {
  filter: grayscale(1);
}
/*# sourceMappingURL=api-call-gate.component.css.map */
